var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99644 2.79102L4.42686 1.93019C4.73741 1.30909 5.37222 0.916748 6.06664 0.916748H15.9336C16.628 0.916748 17.2628 1.30909 17.5734 1.93019L18.0038 2.79102C18.6759 2.93557 19.2243 3.45057 19.3963 4.13877L19.8547 5.9721C20.1002 6.95439 19.503 7.94977 18.5207 8.19534C18.4195 8.22065 18.3164 8.23724 18.2125 8.245L16.3785 21.0834H5.62175L3.78771 8.24508C2.83891 8.17528 2.09082 7.38337 2.09082 6.41675C2.09082 6.26685 2.1092 6.11752 2.14556 5.9721L2.60389 4.13877C2.77594 3.45057 3.32433 2.93557 3.99644 2.79102ZM5.64037 8.25008H16.3598L14.7884 19.2501H7.21179L5.64037 8.25008ZM4.38249 4.58341H5.14997L6.06664 2.75008H15.9336L16.8502 4.58341H17.6177L18.0761 6.41675H3.92415L4.38249 4.58341Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.bcd2fb04cc72309c1b3fff058da54e5c.svg";
export { ForwardRef as ReactComponent };